import useMediaQuery from '@mui/material/useMediaQuery';

export function useGetPageSize() {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('desktop'));
  const isTablet = useMediaQuery((theme) =>
    theme.breakpoints.between('tablet', 'desktop'),
  );
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('tablet'));
  return { isDesktop, isTablet, isMobile };
}
